import React from 'react';
import { Box, Tabs, Tab, Container } from '@mui/material';

interface RegistrationTabsSectionProps {
  activeTab: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
}

export const RegistrationTabsSection: React.FC<RegistrationTabsSectionProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <Box sx={{ backgroundColor: '#F9F9FF', borderBottom: 1, borderColor: 'divider' }}>
      <Container maxWidth='lg' sx={{ py: 0 }}>
        <Tabs
          value={activeTab}
          onChange={onTabChange}
          aria-label='companies registration tabs'
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#0D2F60',
            },
            '& .Mui-selected': {
              color: '#0D2F60 !important',
            },
          }}
        >
          <Tab
            label='得意先'
            id='companies-tab-0'
            aria-controls='companies-tabpanel-0'
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'none',
              minWidth: 120,
              '&.Mui-selected': {
                color: '#0D2F60',
              },
            }}
          />
          <Tab
            label='仕入先'
            id='companies-tab-1'
            aria-controls='companies-tabpanel-1'
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'none',
              minWidth: 120,
              '&.Mui-selected': {
                color: '#0D2F60',
              },
            }}
          />
          <Tab
            label='建設会社'
            id='companies-tab-2'
            aria-controls='companies-tabpanel-2'
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'none',
              minWidth: 120,
            }}
          />
          <Tab
            label='立会会社'
            id='companies-tab-3'
            aria-controls='companies-tabpanel-3'
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'none',
              minWidth: 120,
            }}
          />
        </Tabs>
      </Container>
    </Box>
  );
};
